import(/* webpackMode: "eager" */ "/home/ubuntu/download/695d570b7683ed0014bb82c7/code_spring_financials/src/app/founder/page.tsx");
